/* unplugin-vue-components disabled */
import TopicTile from '../topic-tile.vue'
import PulseNum from '../pulse-num.vue'
import TrackerSelect from './tracker-select.vue'
import TrackerDelete from './tracker-delete.vue'
import $topics from 'stores/topics2'

export default {
  components: {TopicTile, PulseNum, TrackerSelect, TrackerDelete},
  props: {
    item: {type: Object, required: true},
    chosenId: {type: String, default: undefined}
  },
  computed: {
    options() {
      return [
        {title: 'Edit topic', icon: 'hash-02-a', onClick: () => this.$dispatch('edit-topic', {topic_id: this.item.id})},
        {title: 'Delete topic', icon: 'trash-2', onClick: this.onDelete}
      ]
    }
  },
  methods: {
    async onDelete() {
      try {
        const topic = await $topics.loadTopic(this.item.id)
        this.$refs.delete.open(topic)
      } catch (err) {
        $utils.toasts.error('Failed to load this topic. Please try again.')
      }
    }
  }
}
